module.exports = __webpack_public_path__ + "a17d279f/img/share-icon.0f8a11b4.svg";